import { render } from "./PromotorsView.vue?vue&type=template&id=4caa4750&ts=true"
import script from "./PromotorsView.vue?vue&type=script&lang=ts"
export * from "./PromotorsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Promotors/PromotorsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4caa4750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4caa4750', __exports__)) {
    api.reload('4caa4750', __exports__)
  }
  
  module.hot.accept("./PromotorsView.vue?vue&type=template&id=4caa4750&ts=true", () => {
    api.rerender('4caa4750', render)
  })

}


export default __exports__